/**
 * Event bridge for the DXF export dialog (version selection + native save
 * dialog). Command runners dispatch the request; ProjectDialogsHost mounts
 * the dialog component — neither side imports the other directly.
 */

import type { Entity, Layer } from '../../../state/store';
import type { BlockDef } from '../../../state/commandAuxStores';

export interface DxfExportRequest {
    /** 'drawing' = whole ledger, 'wblock' = pre-closed subset. */
    mode: 'drawing' | 'wblock';
    /** Suggested file name (without extension). */
    fileName?: string;
    /** Subset entities (WBLOCK). Omitted = whole drawing. */
    entities?: Entity[];
    /** Dependency-closed block definitions (WBLOCK). */
    blocks?: BlockDef[];
    /** Dependency-closed layers (WBLOCK). */
    layers?: Layer[];
}

export const DXF_EXPORT_DIALOG_EVENT = 'yap:open-dxf-export-dialog';

export function openDxfExportDialog(request: DxfExportRequest): void {
    window.dispatchEvent(new CustomEvent(DXF_EXPORT_DIALOG_EVENT, { detail: request }));
}
